var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('toggleSwitch2',{attrs:{"title":_vm.$t('survey.showInCalendar'),"help":'',"value":_vm.data,"callback":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }